<template>
  <div>
    <v-row>
      <v-col>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card >
            <v-card-title>
              <span> Document Preview </span>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1" 
                text 
                @click="print()"
                :disabled="notYetLoaded"
              >
                Print
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                    <v-col cols="12" sm="6" md="7">
                        <span><b>TRACER#:</b> <b>{{ document.transaction_id}}</b></span>
                    </v-col>
                    <v-col cols="6" md="5">
                        <span><b>Date:</b> {{ document.date }}</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="pb-0">
                        <span><b>Subject:</b> {{ document.subject}}</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="pt-0">
                        <span><b>Document Type:</b> {{ document.document_type ? document.document_type.name : ""}}</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="pb-0">
                        <span><b>Sender:</b> {{ document.sender}}</span>
                    </v-col>
                </v-row>
                <v-row>
                    <!-- need to create/update fetch to get assigned routes for initiate doucments-->
                    <v-col cols="12" class="pt-0">
                        <span><b>Receiver/s: (TBA)</b> 
                            <span v-for="(item, index) in addedReceivers" :key="item.index">{{item.user.name}}<span v-if="index < addedReceivers.length - 1">, </span></span>
                        </span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <span><b>Document:</b> <a style="text-decoration:none" :href="file_url" target="_blank">{{document.filepath_url}}</a></span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <span><b>Added by:</b> {{loggedInUserName}}</span>
                    </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions style="padding-right: 24px; padding-bottom:16px">
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close()">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <DocumentPage
      :dialog="isPrint"
      :document="document"
      :addedReceivers="addedReceivers"
      @closeDialog="closePrintPreview"
      :allsubroutes="allsubroutes"
    />
  </div>
</template>

<script>
import { fileSystemUrl } from '../../../config/config.json'
import { mapActions, mapGetters } from "vuex"
import DocumentPage from './DocumentPage.vue'
export default {
  name: "DocumentTypeModal",
  props: {
    dialog: Boolean,
    document: Object,
    addedReceivers: Array
  },
  components: {
      DocumentPage
  },
  data() {
    return {
      details: "",
      updateItem: null,
      selected: [],
      file_url: "",
      isPrint: false,
      notYetLoaded: true, 
      allsubroutes: null
    };
  },
  computed: {
    ...mapGetters(["loggedInUserName", "loggedInUserID"]),
  },
  methods: {
    ...mapActions(["fetchRejectedDocuments","attachDocuments", "clearReceivers", "initiateDocumentRouteRequest", "fetchPendingInitiateDocuments", "fetchAssignedSubRoutesById"]),
    close() {
      this.details = "";
      this.$emit("closeDialog", false);
      this.selected = []
      this.loading = false;
      this.clearReceivers();
    },
    closePrintPreview(){
        this.isPrint = false
    },
    print() {
      this.isPrint = true;
    },
  },
  watch: {
    allsubroutes() {
      this.notYetLoaded = false;
    },
      dialog: {
        async handler() {
            this.notYetLoaded = true;
            this.file_url = `${fileSystemUrl}/view/${this.document.filepath_url}`
            if(this.dialog){
              await this.fetchAssignedSubRoutesById(this.loggedInUserID).then((res)=> this.allsubroutes = res.allsubroutes)
            }
        },
      }, 
  },
};
</script>

<style>
</style>